<h2 class="title">Panel {{user?.partner_id ? 'Partnera' : 'Użytkownika'}}</h2>
<div class="dashboard-container">
  <!-- Left Column: Submenu -->

  @if (!isAcceptedPolicy) {
    <div class="policy-acceptance-section">
      <div class="warning-message"
        style="color: #c62828; padding: 15px; background: #ffebee; border-radius: 4px; margin-bottom: 20px;">
        <strong>Uwaga:</strong> Aby korzystać z programu ZGrane Grono, musisz zaakceptować regulamin.
      </div>
      <form [formGroup]="acceptForm">
        <div class="checkbox-container">
          <mat-checkbox formControlName="acceptPolicy" (change)="onPolicyAcceptanceChange()">
            Oświadczam, że zapoznałem/am się z regulaminem Programu ZGrane Grono.
            <span (click)="$event.stopPropagation(); $event.preventDefault()" (mousedown)="$event.stopPropagation()">
              <app-info-help [pageId]="'polityka_prywatnosci'" [title]="'Polityka prywatności'">
              </app-info-help>
            </span>
          </mat-checkbox>
          @if (acceptForm.get('acceptPolicy')?.invalid && acceptForm.get('acceptPolicy')?.touched) {
            <div class="error-message"
              style="color: #c62828; margin-top: 5px;">
              Musisz zaakceptować politykę prywatności
            </div>
          }
        </div>
      </form>
    </div>
  }

  @if (isAcceptedPolicy) {
    <div class="submenu">
      <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="onTabChanged($event.index)">
        @if (user?.partner_id && user.partner_id > 0) {
          <mat-tab label="Kampanie">
            <app-camapigns></app-camapigns>
          </mat-tab>
        }
        @if (false && user?.partner_id && user.partner_id > 0) {
          <mat-tab label="Produkty za punkty">
            <app-partner-products></app-partner-products>`
          </mat-tab>
        }
        @if (false && user?.partner_id && user.partner_id > 0) {
          <mat-tab label="Dane Partnera">
            <app-parnter-edit #partnerEditComp></app-parnter-edit>
          </mat-tab>
        }
        @if ((!user?.partner_id || user.partner_id <= 0) && !user?.is_children) {
          <mat-tab label="Twoje wnioski o kartę">
            <persons-table [persons]="persons" (personChanged)="onPersonChanged()"></persons-table>
          </mat-tab>
        }
        <mat-tab label="Dane logowania">
          <basic-data [user]="user ? user : null"></basic-data>
        </mat-tab>
        <mat-tab label="Usuń konto (RODO)">
          <app-rodo></app-rodo>
        </mat-tab>
      </mat-tab-group>
    </div>
  }
</div>